/**
 * Builds the shareable public join URL for a league's invite code — what should be copied
 * and shared, as opposed to the bare code (which only works typed manually into the
 * authenticated /leagues/join flow). Uses window.location.origin rather than a hardcoded
 * domain so this works correctly in every environment (prod, preview, local dev).
 */
export function buildJoinUrl(inviteCode: string): string {
  return `${window.location.origin}/join/${inviteCode}`;
}
